import { DiscountUnits } from '@invivodf/module-discount-sdk'

export const DISCOUNT_UNITS = [
  { value: DiscountUnits.Euro, text: '€' },
  { value: DiscountUnits.Percentage, text: '%' },
]
